import verifyTokenGuardWithoutPermission from "@/guards/verifyTokenGuardWithoutPermission";

export default {
  name: "terapist-options",
  component: () => import(/* webpackChunkName: "auth-layout" */ "@/layouts/BlankLayout.vue"),
  children: [
    {
      path: "",
      name: "psicologists-options",
      //beforeEnter: [verifyTokenGuardWithoutPermission],
      component: () => import(
          /* webpackChunkName: "landing-page" */ "@/modules/psycologists-options/views/Index.vue"
        ),
    },
    {
      path: "details/:id",
      name: "psychologist-details",
      beforeEnter: [verifyTokenGuardWithoutPermission],
      component: () => import(
          /* webpackChunkName: "psychologist-details" */ "@/modules/psycologists-options/views/psychologist.vue"
        ),
    },
    
  ],
};